import { useLocalStorage, useMedia } from 'react-use'

export function useTabletMode(key: string) {
  const isTouchDevice = useMedia('(pointer: coarse)')
  const [isTabletMode = false, setIsTabletMode] = useLocalStorage(
    key,
    isTouchDevice
  )

  return [isTabletMode, setIsTabletMode] as const
}

export function TabletModeCheckbox({
  checked,
  onChange
}: {
  checked: boolean
  onChange: (checked: boolean) => void
}) {
  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        margin: 0,
        fontSize: '1rem',
        lineHeight: 1,
        cursor: 'pointer'
      }}
    >
      <input
        type='checkbox'
        checked={checked}
        onChange={(event) => onChange(event.currentTarget.checked)}
      />
      <span>Tablet Modus</span>
    </label>
  )
}
